/* sb-dc-tplsearch.js - names on the cards, a search box, and no more
   "Load more". 2026-09-12 (v3).

   Reported (feedback item 12): entering the templates page with no product
   shows 1,741 mixed designs; the cards carry no visible name (it is in the
   title attribute, so only a hover reveals it) and there is no search, so the
   only way through is clicking "Load more designs" over and over.

   MEASURED (live): #sbdt-grid renders 50 cards at a time, each a
   div.sbdt-card[title="<design name>"], with the next batch behind a "Load
   more designs" button inside #sbdt-more.

   THREE THINGS, all on top of the existing page - the grid, the filters and
   the data loading are untouched:

     NAMES     the title attribute is already the name; it is written under
               each thumbnail as well.
     SEARCH    a box above the grid. Typing hides cards whose name does not
               match, and pulls in further batches so the search reaches past
               the fifty cards on screen.
     SCROLL    reaching the bottom clicks "Load more" for you. The button is
               left in place and still works - this only saves the click.

   TWO WAYS THIS FROZE THE TAB BEFORE. Both are worth knowing, because the
   obvious version of this file hits them:

     v1 kept clicking "Load more" until the whole library was in the page.
     1,700-odd cards with thumbnails is past what the page will hold. v2 added
     LOAD_CAP, and stops earlier once ENOUGH matches are on screen - nobody
     scrolls past forty results.

     v2 still locked up, and the cap was not the problem: writing a name into
     a card is a DOM change, which woke the MutationObserver, which named
     again, which woke it again. With a document-wide observer and a 600ms
     sweep over every card on top, the page spent all its time on us. v3
     watches only #sbdt-grid, only childList, disconnects while it writes,
     debounces, and tracks which cards it has already named instead of
     rescanning all of them.

   NOT DONE: the "choose a product first" screen the feedback also suggests.
   That changes what the page does when someone arrives without a product,
   which is a decision about the flow rather than a gap in it - worth asking
   the store first.

   Diagnostics: window.__dcTplSearch() */
(function () {
  'use strict';

  var LOAD_CAP = 400;      // cards in the page; past this the tab struggles
  var ENOUGH = 40;         // matches that make further loading pointless
  var STEP_MS = 650;
  var DEBOUNCE = 150;

  var info = { named: 0, shown: 0, hidden: 0, loaded: 0, autoLoads: 0,
               passes: 0, query: '', capped: false };
  window.__dcTplSearch = function () { return info; };

  function grid() { return document.getElementById('sbdt-grid'); }
  function cards() {
    var g = grid();
    return g ? g.querySelectorAll('.sbdt-card') : [];
  }
  function moreBtn() {
    var box = document.getElementById('sbdt-more');
    if (!box) return null;
    var b = box.querySelector('button');
    return (b && b.offsetParent !== null) ? b : null;
  }

  function css() {
    if (document.getElementById('sbdt-search-css')) return;
    var st = document.createElement('style');
    st.id = 'sbdt-search-css';
    st.textContent =
      '.sbdt-name{display:block;margin-top:6px;font:500 12px/1.35 Arial,Helvetica,sans-serif;' +
      'color:#4a5763;text-align:center;word-break:break-word;}' +
      '#sbdt-searchwrap{display:flex;align-items:center;gap:8px;margin:0 0 14px;}' +
      '#sbdt-search{flex:1;max-width:420px;font:400 14px/1.3 Arial,Helvetica,sans-serif;' +
      'padding:10px 12px;border:1px solid #c8d2dd;border-radius:10px;color:#072747;background:#fff;}' +
      '#sbdt-searchcount{font:400 12.5px/1.3 Arial,Helvetica,sans-serif;color:#6b7885;}';
    document.head.appendChild(st);
  }

  var obs = null;
  function quiet(fn) {            // write without waking ourselves up
    if (obs) obs.disconnect();
    try { fn(); } catch (e) { info.why = String(e && e.message).slice(0, 60); }
    watch();
  }

  /* ---- names + filter, in one walk -------------------------------------- */

  function sweep() {
    info.passes++;
    var list = cards();
    info.loaded = list.length;
    var q = info.query.toLowerCase();
    var shown = 0, hidden = 0;

    quiet(function () {
      for (var i = 0; i < list.length; i++) {
        var c = list[i];
        if (!c.getAttribute('data-sbdt-named')) {
          var t = (c.getAttribute('title') || c.getAttribute('aria-label') || '')
                    .replace(/^Design with\s+/i, '').trim();
          if (t) {
            var el = document.createElement('span');
            el.className = 'sbdt-name';
            el.textContent = t;
            c.appendChild(el);
            info.named++;
          }
          c.setAttribute('data-sbdt-named', '1');
        }
        if (q) {
          var hit = (c.getAttribute('title') || '').toLowerCase().indexOf(q) > -1;
          c.style.display = hit ? '' : 'none';
          if (hit) shown++; else hidden++;
        } else if (c.style.display === 'none') {
          c.style.display = '';
        }
      }
    });

    info.shown = q ? shown : list.length;
    info.hidden = q ? hidden : 0;

    var c2 = document.getElementById('sbdt-searchcount');
    if (c2) {
      c2.textContent = !q ? ''
        : info.shown + ' match' + (info.shown === 1 ? '' : 'es')
          + (info.capped ? ' in the first ' + list.length + ' designs' : '');
    }
  }

  /* ---- search box -------------------------------------------------------- */

  var box = null;
  function buildBox() {
    if (box && document.body.contains(box)) return;
    var g = grid();
    if (!g || !g.parentElement) return;

    box = document.createElement('div');
    box.id = 'sbdt-searchwrap';

    var input = document.createElement('input');
    input.id = 'sbdt-search';
    input.type = 'search';
    input.placeholder = 'Search designs by name...';
    input.autocomplete = 'off';

    var count = document.createElement('span');
    count.id = 'sbdt-searchcount';

    input.addEventListener('input', function () {
      info.query = input.value.trim();
      info.capped = false;
      sweep();
      if (info.query) pull();
    });

    box.appendChild(input);
    box.appendChild(count);
    quiet(function () { g.parentElement.insertBefore(box, g); });
  }

  /* Pull further batches while a search is running - bounded twice over. */
  var pulling = false;
  function pull() {
    if (pulling) return;
    pulling = true;
    (function step() {
      if (!info.query) { pulling = false; return; }
      if (info.shown >= ENOUGH || info.loaded >= LOAD_CAP) {
        info.capped = true; pulling = false; sweep(); return;
      }
      var b = moreBtn();
      if (!b) { pulling = false; sweep(); return; }
      b.click();
      info.autoLoads++;
      setTimeout(function () { sweep(); step(); }, STEP_MS);
    })();
  }

  /* ---- infinite scroll --------------------------------------------------- */

  function nearBottom() {
    var box2 = document.getElementById('sbdt-more');
    if (!box2) return false;
    var r = box2.getBoundingClientRect();
    return r.top < (window.innerHeight + 300);
  }

  var lastAuto = 0;
  function autoScrollLoad() {
    if (info.query) return;                       // search does its own pulling
    if (Date.now() - lastAuto < 800) return;
    if (info.loaded >= LOAD_CAP) return;
    var b = moreBtn();
    if (b && nearBottom()) { lastAuto = Date.now(); b.click(); info.autoLoads++; }
  }

  /* ---- run --------------------------------------------------------------- */

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; buildBox(); sweep(); }, DEBOUNCE);
  }

  function watch() {
    var g = grid();
    if (!g) return;
    if (!obs) obs = new MutationObserver(schedule);
    obs.observe(g, { childList: true });          // grid only, no subtree
  }

  function start() {
    css();
    buildBox();
    sweep();
    watch();
    window.addEventListener('scroll', autoScrollLoad, { passive: true });
    /* the page can replace the grid node when a filter changes; cheap re-check */
    setInterval(function () { buildBox(); watch(); }, 2000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
